// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalBackground {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px; /* Height of your navbar */
  width: 100%;
  background-color: var(--background);
  color: var(--theme);
  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  /* Add padding for iOS safe areas */
  padding: 8px 8px calc(8px + env(safe-area-inset-bottom)) 8px;
}

.modalHeader {
  width: 90%;
  position: sticky;
  top: 2rem;
}

.modalTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 8px 4px 8px;
  font-size: 1rem;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.modalDescription {
  font-size: 16px;
  text-align: justify;
  padding: 12px;
  background-color: #ffffff12;
  border-radius: 4px;
  border: 1px solid #ffffff4b;
  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin: 1rem 12px 0px 12px;
  margin-top: 50px;
}

.modalGenres {
  text-align: center;
}

.modalGenre {
  text-align: center;
  background-color: rgba(0, 0, 0, 0.1);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  border: 1px solid #d7d7d7;
  padding: 4px 7px;
  border-radius: 4px;
  justify-content: right;
  width: 100%;
  margin: 4px;
  display: inline-block;
  font-size: 1rem;
  margin-top: 1rem;
}

.titleCloseBtn {
  display: flex;
  justify-content: flex-end;
  position: fixed;
  right: 15px;
  top: 50px;
  cursor: pointer;
  z-index: 4;
}

.modalBody {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Add padding at bottom to prevent content from being cut off */
  padding-bottom: 100px;
}

.modalBody::-webkit-scrollbar {
  display: none;
}

.modalTrailer {
  height: 32vh;
  width: 95vw;
}

.loader {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  /* top: 30%; */
}

.video {
  padding-top: 8px;
  margin-top: 60px;
  text-align: center;
}

.modalRating {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.modalRating ul {
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin-top: 1rem;
}

.modalRating li {
  display: flex;
  align-items: center;
  margin: 0 10px;
}


/* Mobile devices */
@media (max-width: 767px) {
  .modalDescription {
    font-size: 1rem;
  }

  .modalTrailer {
    height: 40vh;
    width: 90vw;
  }

  .modalGenre {
    font-size: 0.875rem;
    width: 100px;
  }
}

/* Tablet devices */
@media (min-width: 768px) and (max-width: 1024px) {
  .modalDescription {
    font-size: 1.125rem;
  }

  .modalTrailer {
    height: 45vh;
    width: 90vw;
  }

  .modalGenre {
    font-size: 1.125rem;
    width: 100px;
  }

  .modalHeader {
    padding: 18px;
  }
}

/* Desktop devices */
@media (min-width: 1025px) {
  .modalDescription {
    font-size: 1.375rem;
  }

  .modalTrailer {
    height: 50vh;
    width: 80vw;
  }

  .modalGenre {
    font-size: 1.25rem;
    width: 100px;
  }

  .modalHeader {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,0BAA0B;EACxC,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC,EAAE,4BAA4B;EAC/D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gEAAgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,mBAAmB;AACnB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".modalBackground {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 50px; /* Height of your navbar */\n  width: 100%;\n  background-color: var(--background);\n  color: var(--theme);\n  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  /* Add padding for iOS safe areas */\n  padding: 8px 8px calc(8px + env(safe-area-inset-bottom)) 8px;\n}\n\n.modalHeader {\n  width: 90%;\n  position: sticky;\n  top: 2rem;\n}\n\n.modalTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 8px 4px 8px;\n  font-size: 1rem;\n  text-align: center;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.modalDescription {\n  font-size: 16px;\n  text-align: justify;\n  padding: 12px;\n  background-color: #ffffff12;\n  border-radius: 4px;\n  border: 1px solid #ffffff4b;\n  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  margin: 1rem 12px 0px 12px;\n  margin-top: 50px;\n}\n\n.modalGenres {\n  text-align: center;\n}\n\n.modalGenre {\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.1);\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  border: 1px solid #d7d7d7;\n  padding: 4px 7px;\n  border-radius: 4px;\n  justify-content: right;\n  width: 100%;\n  margin: 4px;\n  display: inline-block;\n  font-size: 1rem;\n  margin-top: 1rem;\n}\n\n.titleCloseBtn {\n  display: flex;\n  justify-content: flex-end;\n  position: fixed;\n  right: 15px;\n  top: 50px;\n  cursor: pointer;\n  z-index: 4;\n}\n\n.modalBody {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* Add padding at bottom to prevent content from being cut off */\n  padding-bottom: 100px;\n}\n\n.modalBody::-webkit-scrollbar {\n  display: none;\n}\n\n.modalTrailer {\n  height: 32vh;\n  width: 95vw;\n}\n\n.loader {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  text-align: center;\n  /* top: 30%; */\n}\n\n.video {\n  padding-top: 8px;\n  margin-top: 60px;\n  text-align: center;\n}\n\n.modalRating {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.modalRating ul {\n  list-style-type: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin-top: 1rem;\n}\n\n.modalRating li {\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n\n\n/* Mobile devices */\n@media (max-width: 767px) {\n  .modalDescription {\n    font-size: 1rem;\n  }\n\n  .modalTrailer {\n    height: 40vh;\n    width: 90vw;\n  }\n\n  .modalGenre {\n    font-size: 0.875rem;\n    width: 100px;\n  }\n}\n\n/* Tablet devices */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .modalDescription {\n    font-size: 1.125rem;\n  }\n\n  .modalTrailer {\n    height: 45vh;\n    width: 90vw;\n  }\n\n  .modalGenre {\n    font-size: 1.125rem;\n    width: 100px;\n  }\n\n  .modalHeader {\n    padding: 18px;\n  }\n}\n\n/* Desktop devices */\n@media (min-width: 1025px) {\n  .modalDescription {\n    font-size: 1.375rem;\n  }\n\n  .modalTrailer {\n    height: 50vh;\n    width: 80vw;\n  }\n\n  .modalGenre {\n    font-size: 1.25rem;\n    width: 100px;\n  }\n\n  .modalHeader {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
